// extracted by mini-css-extract-plugin
export default {"splash":"Splash_splash__Ddho1","title":"Splash_title__umO8N","subtitle":"Splash_subtitle__SEsUn","footer":"Splash_footer__MNNPg"};